var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTekegramm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38394 12.5342L9.3689 19.9965L13.2554 16.1099L19.9028 21.3938L24.7267 0.666992L0.679688 10.3177L6.38394 12.5342ZM4.50839 10.2966L15.9705 5.69647L6.85545 11.2086L4.50839 10.2966ZM18.013 6.10486L10.4053 13.0647L9.49017 16.5133L7.79772 12.2823L18.013 6.10486ZM10.9749 16.4014L11.436 14.6638L12.1473 15.2291L10.9749 16.4014ZM19.0371 18.9092L12.1148 13.4069L22.5368 3.87229L19.0371 18.9092Z",
    fill: "#3479EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTekegramm);
export default __webpack_public_path__ + "static/media/Tekegramm.be19575c1a5b60bf75f04866afb071aa.svg";
export { ForwardRef as ReactComponent };